import styled from 'styled-components';
import { Button, FormLoader } from '@teamfabric/copilot-ui';
import { useState } from 'react';
import { Editor } from 'components/Editor/TransformationEditor';
import { useFormik } from 'formik';
import { Text, Card } from '@mantine/core';
import { makePost } from 'utils/httpWrapper';
import { BASE_ERROR_CONSTANT } from 'utils/constants';

const StyledContainer = styled.div`
  .wrapper-add-schema {
    display: flex;
    justify-content: center;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
`;

const StyledEditorWrapper = styled.div`
  display: grid;
  column-gap: 10px;
  .editor__labels {
    margin: 12px 0 6px 6px;
  }
  .editor__transformation-response {
    height: 438px;
  }
`;

const TestEndpoint = ({ data }) => {
  const { endpoints, endpointIndex } = data;

  const [loading, setLoading] = useState(false);
  const [initialValues] = useState({
    variableValue: '0',
    endpointResult: '',
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values, action) => {
      setLoading(true);
      action.setFieldValue('endpointResult', '');
      const body = endpoints[endpointIndex];
      try {
        const url = `/debugging/validate/endpoint`;
        const resp = await makePost({ url, body });
        if (resp['data']) {
          action.setFieldValue('endpointResult', JSON.stringify(resp['data'], null, 2));
        }
      } catch (err) {
        action.setFieldValue('endpointResult', BASE_ERROR_CONSTANT);
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <StyledContainer>
      <ActionsContainer>
        <Button
          type="button"
          isPrimary={false}
          onClick={formik.resetForm}
          text="Reset"
          style={{ marginRight: '12px' }}
        />
        <div>
          <Button
            disabled={formik.values.variableValue ? false : true}
            type="submit"
            form="schemaDetailsForm"
            onClick={formik.handleSubmit}
            size="small"
            text="Run"
          />
        </div>
      </ActionsContainer>
      <StyledEditorWrapper>
        {loading && <FormLoader theme="dark" rowCount={5} />}
        {!loading && (
          <Card style={{ marginTop: '10px' }}>
            <Card.Section>
              <Text weight={500} className="editor__labels" size="sm">
                Endpoint Result
              </Text>
              <Editor
                className="editor__transformation-response"
                readOnly={true}
                required={true}
                value={formik.values.endpointResult}
                placeholder="Expected Output"
              />
            </Card.Section>
          </Card>
        )}
      </StyledEditorWrapper>
    </StyledContainer>
  );
};

export default TestEndpoint;
